import { createContext } from "react"

const BankDetailsContext = createContext({})

const { Provider, Consumer } = BankDetailsContext

export { Provider, Consumer, BankDetailsContext }
